import React from 'react';

const HeadingH1 = (props) => {

    const { size, weight, color } = props;

    let className= '';
    className += 'u-fontSize' + size;
    className += ' u-fontWeight' + weight;
    className += ' u-textColor' + color;

    return (
        <h1 className={className}>{props.children}</h1>
    );
}

export default HeadingH1;


// WEBPACK FOOTER //
// ./src/components/UI/Headings/HeadingH1/HeadingH1.js